import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import {BASE_URL} from '../../lib/constant';
import { useParams , useSearchParams,useNavigate } from "react-router-dom";
import SlectInputField from "../SlectInputField";
import { Container, Row, Col, Tab, Form, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import Loader from '../Common/loader';
import "./ProductComparison.styles.css";

const ProductComparison = ({modelView}) => {

  const [comapreProducts, setComapreProducts] = useState(false); 
  const comapreProductDetails = useRef([]); 
  const totalComapreProduct = useRef(0); 

  const getProductDetails = async () => {
    await AuthVerify.compareProducts().then(async (data) => {
      if(data){
        totalComapreProduct.current=data.length;
        let products=[];
        data.forEach(async (product) => {
          await Axios.get("product/productdetails/"+product)
          .then(function (response) {
              if (response && response.data) {
                comapreProductDetails.current.push({matm:response.data?.matm,specs:response.data?.specs});
                loadProductDetails();
              }
          })
        });
      };
    })
  };
  useEffect(async () => {
    getProductDetails();
  },[])

  const loadProductDetails = () => {
    if(comapreProductDetails.current.length==totalComapreProduct.current && totalComapreProduct.current>0){
        let customData=[]
        comapreProductDetails.current.forEach(function (item) {
          if(!customData.imageurl)customData.imageurl=[]
          customData.imageurl.push(item.matm.imageurl)

          if(!customData.matnum)customData.matnum=[]
          customData.matnum.push(item.matm.matnum)

          if(!customData.matname)customData.matname=[]
          customData.matname.push(item.matm.matname)

          if(!customData.rating)customData.rating=[]
          customData.rating.push(item.matm.rating)

          if(!customData.sellingprice)customData.sellingprice=[]
          customData.sellingprice.push(item.matm.sellingprice)

          if(!customData.gstprice)customData.gstprice=[]
          customData.gstprice.push(item.matm.gstprice)

          if(!customData.specs)customData.specs=[]
          customData.specs.push(item.specs ? item.specs:[])
        });
        setComapreProducts(customData);
    }
  };
  const RenderSpecs=({specs})=>{
    return (
      <ul>
        {
          specs && specs.map((data,i) => (
            <li key={i}>
              <span style={{fontWeight:"bold"}}>{data.specname}</span>&nbsp;:&nbsp;
              <span>{data.description}</span>
            </li>
          ))
        }
      </ul>
    )
  }
  return (
    <div className="col-main">
      <div className="my-account">
        {/* <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>My comapreProducts</h2>
          <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p>
        </div>
        <hr/> */}
        <div className="dashboard">
          <div className="box-account" style={{ display: "grid" }}>
            <div className="header-nav-dropdown-wrapper">
              {comapreProducts && <>
                {/* <Col sm={12} style={{padding:"0px"}}>
                  <Col sm={3} style={{padding:"0px"}}>
                    <input type="text" placeholder="Search..." style={{marginRight: "0px",padding:"4px"}} />
                    <button type="button" style={{ padding:"5px 10px", borderRadius:"3px"}}>
                        <span className="glyphicon glyphicon-search"></span>
                    </button>
                  </Col>
                </Col>
                <br/>
                <br/> */}
                <Col sm={12}>
                  <Table striped responsive="md" className='osya'>
                  {/* <thead>
                      <tr className="first last">
                          <th>Brought Forward</th>
                          <th>Image</th>
                      </tr>
                  </thead> */}
                  <tbody>
                      <tr>
                          <td style={{padding:"6px",textAlign:"center"}}>
                            <span style={{}}></span>
                          </td>
                          {comapreProducts.imageurl.map((item,i)=>{
                            return(<td style={{padding:"6px"}} key={i}>
                              <Link to={"/product-detail?matnum="+comapreProducts.matnum[i]}>
                                <img
                                    // src={img03}
                                    className='comapreProductImage'
                                    // src={BASE_URL+item}
                                    src={AuthVerify.getImageLink(item)}
                                />
                              </Link>
                            </td>)
                          })}
                      </tr>
                      <tr>
                          <td style={{padding:"6px",textAlign:"center"}}>
                            <span style={{}}>Name</span>
                          </td>
                          {comapreProducts.matname.map((item,i)=>{
                            return(<td style={{padding:"6px"}} key={i}>{item}</td>)
                          })}
                      </tr>
                      <tr>
                          <td style={{padding:"6px",textAlign:"center"}}>
                            <span style={{}}>Rating</span>
                          </td>
                          {comapreProducts.rating.map((item,i)=>{
                            return(<td style={{padding:"6px"}} key={i}>
                              <div className="rating">
                                <i className={item>0?"fa fa-star":"fa fa-star-o"}></i>
                                <i className={item>1?"fa fa-star":"fa fa-star-o"}></i>
                                <i className={item>2?"fa fa-star":"fa fa-star-o"}></i>
                                <i className={item>3?"fa fa-star":"fa fa-star-o"}></i>
                                <i className={item>4?"fa fa-star":"fa fa-star-o"}></i>
                              </div>
                            </td>)
                          })}
                      </tr>
                      <tr>
                          <td style={{padding:"6px",textAlign:"center"}}>
                            <span style={{}}>Selling price</span>
                          </td>
                          {comapreProducts.sellingprice.map((item,i)=>{
                            return(<td style={{padding:"6px"}} key={i}>S${item} (w/GST S${comapreProducts.gstprice[i]})</td>)
                          })}
                      </tr>
                      <tr>
                          <td style={{padding:"6px",textAlign:"center"}}>
                            <span style={{}}>Specifications</span>
                          </td>
                          {comapreProducts.specs.map((item,i)=>{
                            return(<td style={{padding:"6px"}} key={i}><RenderSpecs specs={item}/></td>)
                          })}
                      </tr>
                  </tbody>
                  </Table>
                </Col>
                </>
              }
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default ProductComparison;
